import { Component } from 'react';
import { connect, PromiseState } from 'react-refetch';

import Icon from 'react-fa';

import { api } from '../../data';

class Footer extends Component {
  render() {

    const info = this.props.info;

    return (
      <footer className="footer">
        <div className="inner">
          {info.footer_desc
            ? <div className="desc" dangerouslySetInnerHTML={{__html: info.footer_desc}} />
            : ''
          }
          {info.footer_phone_number
            ?
              <div className="phone-number">
                <Icon name="phone" className="phone" />
                <div className="number" dangerouslySetInnerHTML={{__html: info.footer_phone_number}} />
              </div>
            : ''
          }
          {info.footer_fax
            ? <p className="fax">{`FAX: ${info.footer_fax}`}</p>
            : ''
          }
          <small className="copyright">Copyright NPO Sukoyaka Network <span className="copyright__mark">&copy;</span> All Rights Reserved.</small>
        </div>
      </footer>
    )
  }
}

class FooterFetch extends Component {
  render() {

    const { pageFetch } = this.props;

    const allFetches = PromiseState.all([pageFetch])

    // Pending
    if (allFetches.pending) {

      return <div />

    // Error
    } else if (allFetches.rejected) {

      return <div>Error</div>

    // Complete without Error
    } else if (allFetches.fulfilled) {

      let [info] = allFetches.value;
      info = info.acf;

      return (
        <Footer info={info} />
      )
    }
  }
}

export default connect(() => ({
  pageFetch: `${api.acf.options}`
}))(FooterFetch);



/** WEBPACK FOOTER **
 ** ./src/components/modules/Footer.js
 **/